module.exports = __webpack_public_path__ + "static/media/new-logo-1.72faaf0e.png";